import { useEffect } from 'react';
import { getCallbackUserManager } from '@components/Auth/manager';
import { MgLocalStorageKeys } from '@enums';

export const useAuth0LoginRefresh = () => {
  const trySignInSilentAsync = async () => {
    const userManager = getCallbackUserManager();
    await userManager.signinSilentCallback();
    localStorage.removeItem(MgLocalStorageKeys.REDIRECT_PATH);
  };

  useEffect(() => {
    trySignInSilentAsync();
  }, []);
};
